"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasurementOverride = void 0;
class MeasurementOverride {
    constructor() {
        this.scale = 1;
        this.unit = "M" /* M */;
    }
}
exports.MeasurementOverride = MeasurementOverride;
